<template>
  <div>
    <div class="wrapper-x-40">
      <h1>{{$t('admin.views.materials.library_materials')}}</h1>
    </div>
    <div class="tabs">
      <div class="wrapper-x-40">
        <button
          :class="{ active: view == 'list' }"
          class="focus:outline-none"
          @click="setView('list')"
        >
          {{$t('main.tab_list')}}
        </button>
        <button
          :class="{ active: view == 'type' }"
          class="focus:outline-none"
          @click="setView('type')"
        >
          {{$t('main.tab_types')}}
        </button>
      </div>
    </div>
    <div class="content">
      <div
        class="wrapper-x-40"
        v-if="view === 'list'"
      >
        <div class="mb-30 action-panel flex items-center justify-between">
          <div>
            <router-link
              class="btn btn-green btn-small"
              :to="{ name: 'add_material' }"
            >{{$t('admin.views.materials.add_material')}}</router-link>
          </div>
          <div class="flex gap-8">
            <div class="form-group w-32">
              <select @change="e=>setType(e.target.value)">
                <option value="0">{{$t('main.all_types')}}</option>
                <option
                  :selected="selectedType&&selectedType == type.data.type_id"
                  v-for="type in types"
                  :value="type.data.type_id"
                  :key="`types-${type.data.type_id}`"
                >
                  {{ type.data.attributes.name }}
                </option>
              </select>
            </div>
          </div>
        </div>

        <div class="flex">
          <div class="list-material list-material-all w-7/12">
            <div class="list-material-header font-bold mb-4">
              {{$t('admin.views.materials.list_of_materials')}}:
            </div>

            <div class="list-material-content flex flex-wrap overflow-x-hidden px-2">
              <MaterialListCard
                :material="material"
                v-for="material in materials"
                :key="material.data.material_id"
              />
            </div>
            <PaginationBar
              :meta="meta"
              :page="page"
              :per-page="per_page"
              :per-pages="perPages"
              @set-page="setPage"
              @set-per-page="setPerPage"
            />

          </div>

          <div class="list-material list-material-main rounded w-5/12 py-2 px-4 ml-6">
            <div class="list-material-header font-bold mb-4">
              {{$t('admin.views.materials.main_set')}}
            </div>
            <div class="list-material-content flex flex-wrap overflow-x-hidden px-2 py-2">
              <MaterialListCard
                :material="material"
                :main-set="true"
                v-for="material in mainMaterials"
                :key="material.data.material_id"
              />
            </div>
          </div>
        </div>
      </div>

      <ListTypes
        v-if="view === 'type'"
        :withoutImage="true"
      />
    </div>
  </div>
</template>

<script>
import MaterialListCard from "../../../components/Admin/Materials/MaterialListCard";
import PaginationBar from "../../../components/Admin/PaginationBar.vue";
import ListTypes from "../../../components/Admin/Types/List";
export default {
  name: "List",
  components: { MaterialListCard, ListTypes, PaginationBar },
  data() {
    return {
      view: "list",
    };
  },
  mounted() {
    if (!this.licensed) this.$router.push({ name: "no_license" });
  },
  created() {
    const view = localStorage.getItem("materials_view");
    this.view = view ? view : "list";
  },
  computed: {
    materials() {
      return this.$store.state.materials.materials;
    },
    mainMaterials() {
      return this.$store.state.materials.main_materials;
    },
    main_set() {
      return this.materials.filter((material) => material.data.attributes.main);
    },
    licensed() {
      return this.$store.getters["licensed"];
    },
    perPages() {
      return this.$store.state.settings.perPages;
    },
    types() {
      return this.$store.state.types.types;
    },
    meta() {
      return this.$store.state.materials.meta;
    },
    page() {
      return this.$store.state.materials.page;
    },
    selectedType() {
      return this.$store.state.materials.type;
    },
    per_page() {
      return this.$store.state.materials.per_page;
    },
  },
  methods: {
    setView(view) {
      localStorage.setItem("materials_view", view);
      this.view = view;
    },
    setPage(page) {
      this.$store.dispatch("materials/setPage", page);
    },
    setType(type) {
      this.$store.dispatch("materials/setType", type);
    },
    setPerPage(perPage) {
      this.$store.dispatch("materials/setPerPage", perPage);
    },
  },
};
</script>
